import React, { useContext, useEffect, useState } from 'react';
import useInsightApi from './useInsightApi';
import { InsightContext } from './insightContext.js';
import usePersonaApi from '@/persona/lib/usePersonaApi';
import useProductsApi from '@/products/lib/useProductsApi';
import { AuthContext } from '@/auth/lib/authContext';
export default function InsightProvider(props) {
  const {
    insightId,
    children,
    fetchPersonaList = 'only-specified',
    fetchProductList = 'only-specified',
    originalInsight,
    originalPersonaList,
    originalProductList,
    originalRights,
    onInit,
    onInsightChange
  } = props;
  const [insight, setInsight] = useState();
  const [personaList, setPersonaList] = useState();
  const [productList, setProductList] = useState();
  const insightApi = useInsightApi();
  const personaApi = usePersonaApi();
  const productApi = useProductsApi();
  const [rights, setRights] = useState({
    can_update: false,
    can_select: false,
    can_delete: false
  });
  const { profile, hasProfile } = useContext(AuthContext);
  const [isReadyToFetch, setIsReadyToFetch] = useState(false);
  const [previouslyReadyToFetch, setPreviouslyReadyToFetch] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const fetchPersonaAndProductList = async () => {
    try {
      if (profile && insight) {
        if (fetchPersonaList && !originalPersonaList) {
          let newPersonaList;
          if(!insight.personas) {
            if (!insight.applicable_to_all_persona) {
              newPersonaList = await personaApi.fetchManyPersonaByInsightId(insight.id);
            } else if (fetchPersonaList === 'always') {
              newPersonaList = await personaApi.fetchManyPersonaByExperienceId(insight.experience_id);
            }
          } else {
            newPersonaList = insight.personas;
          }
          setPersonaList(newPersonaList);
        }
        if (fetchProductList && !originalProductList) {
          let newProductList;
          if(!insight.products) { 
            if (!insight.applicable_to_all_products) {
              newProductList = await productApi.fetchProductsByInsightId(insight.id)
            } else if (fetchPersonaList === 'always') {
              newProductList = await productApi.fetchProductsByExperienceId(insight.experience_id);
            }
          } else {
            newProductList = insight.products;
          }
          setProductList(newProductList);
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
  const refresh = async (options = {skipInsight: false, skipRights: false}) => {
    try {
      if(!options.skipInsight) {
        const newInsight = await insightApi.fetchInsight(insightId);
        setInsight(newInsight);
      } else {
        setInsight(originalInsight);
      }
      if(!options.skipRights) {
        const newRights = await insightApi.fetchUserRights(insightId, profile.id)
        setRights(newRights);
      } else {
        setRights( originalRights)
      }
      if (!isInit && onInit) {
        onInit(true);
        setIsInit(true);
      }
    } catch (e) {
      console.error(e)
    }
  };
  useEffect(() => {
    if (hasProfile && insight) {
      fetchPersonaAndProductList();
    }
  }, [hasProfile, insight]);
  useEffect(() => {
    if(isReadyToFetch && !previouslyReadyToFetch ) {
      setPreviouslyReadyToFetch(true)
      const options =  {
        skipInsight: !!originalInsight,
        skipRights: !!originalRights,
      }
      if (originalInsight) {
        refresh(options)
      } else {
        refresh()
      }
      setIsReadyToFetch(false)
    }
  }, [isReadyToFetch]);
  useEffect(() => {
    if (insightId && hasProfile) {
      setPreviouslyReadyToFetch(false)
      setIsReadyToFetch(true);
      setIsInit(false);
    }
  }, [insightId, hasProfile]);
  useEffect(() => {
    if (originalPersonaList && hasProfile) {
      setPersonaList(originalPersonaList);
    }
  }, [originalPersonaList, hasProfile]);
  useEffect(() => {
    if (originalProductList && hasProfile) {
      setProductList(originalProductList);
    }
  }, [originalProductList, hasProfile]);
  useEffect(() => {
    if (originalInsight && hasProfile) {
      setInsight(originalInsight);
    }
  }, [originalInsight, hasProfile]);
  useEffect(() => {
    if (onInsightChange) {
      onInsightChange();
    }
  }, [insight]);
  return (
    <InsightContext.Provider value={{
      insight,
      insightId,
      refresh,
      personaList,
      productList,
      rights,
    }} >
      {children}
    </InsightContext.Provider>
  );
}